export interface IFoundationApiError {
  data: {
    error: {
      type: string;
    };
  };
  status: number;
}

/**
 * Вернёт true для объекта, который Foundation API вернул при ошибке.
 */
export function isErrorFromFoundationApi(
  error: IFoundationApiError | unknown
): error is IFoundationApiError {
  if (!error) {
    return false;
  }

  const errorObject = error as IFoundationApiError;

  return (
    typeof errorObject === "object" &&
    typeof errorObject.data?.error?.type === "string"
  );
}

export interface IRTKQNetworkRequestError {
  data: string;
  meta: object;
  status: number | undefined;
  code: string;
}

/**
 * Вернёт true для объекта, который RTKQ выдал при сетевой ошибке запроса. Например, у пользователя нет интернета или запрос отвалился по таймауту.
 */
export function isNetworkRequestError(
  error: IRTKQNetworkRequestError | unknown
): error is IRTKQNetworkRequestError {
  if (!error) {
    return false;
  }

  const errorObject = error as IRTKQNetworkRequestError;

  return (
    typeof errorObject === "object" &&
    typeof errorObject.data === "string" &&
    typeof errorObject.meta === "object" &&
    typeof errorObject.code === "string"
  );
}

export interface IErrorLikeObject {
  name: string;
  message: string;
}

export function isErrorLikeObject(
  error: Error | unknown
): error is IErrorLikeObject {
  return (
    typeof error === "object" &&
    error !== null &&
    typeof (error as IErrorLikeObject).name === "string" &&
    typeof (error as IErrorLikeObject).message === "string"
  );
}
